import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"

const formatIso = (date) => flatpickr.formatDate(date, "Y-m-d")

const bindDateFilter = (root) => {
  if (root.dataset.bound === "true") return
  root.dataset.bound = "true"

  const trigger = root.querySelector("[data-participants-date-filter-trigger]")
  const input = root.querySelector("[data-participants-date-filter-input]")
  const form =
    document.querySelector("form[data-participants-date-filter-form]") ||
    document.querySelector("form[data-auto-search]")
  if (!input || !form) return

  const fromParam = root.dataset.dateFromParam || "created_from"
  const toParam = root.dataset.dateToParam || "created_to"
  const fromField = form.querySelector(`[name="${fromParam}"]`)
  const toField = form.querySelector(`[name="${toParam}"]`)
  if (!fromField || !toField) return

  // Filtre déjà actif : toute la pill est un lien de reset, pas de datepicker.
  if (!trigger) return

  const fp = flatpickr(input, {
    mode: "range",
    locale: French,
    dateFormat: "Y-m-d",
    positionElement: trigger,
    static: false,
    onOpen: () => {
      trigger.setAttribute("aria-expanded", "true")
      trigger.classList.add("is-open")
    },
    onClose: (selectedDates) => {
      trigger.setAttribute("aria-expanded", "false")
      trigger.classList.remove("is-open")

      if (!selectedDates.length) return

      const start = selectedDates[0]
      const end = selectedDates[1] || selectedDates[0]
      const nextFrom = formatIso(start)
      const nextTo = formatIso(end)

      if (fromField.value === nextFrom && toField.value === nextTo) return

      fromField.value = nextFrom
      toField.value = nextTo

      if (typeof form.requestSubmit === "function") {
        form.requestSubmit()
      } else {
        form.submit()
      }
    },
  })

  root._flatpickr = fp

  trigger.addEventListener("click", (event) => {
    event.preventDefault()
    fp.toggle()
  })
}

const initBackofficeParticipantsDateFilter = () => {
  document.querySelectorAll("[data-participants-date-filter]").forEach(bindDateFilter)
}

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-participants-date-filter]").forEach((root) => {
    if (root._flatpickr) {
      root._flatpickr.destroy()
      root._flatpickr = null
    }
    root.dataset.bound = "false"
  })
})

export { initBackofficeParticipantsDateFilter }
